"use client";

import React from "react";
import { Mail, Phone, MapPin, Loader, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
const inputStyles = "border-border placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-primary/20 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/10 flex h-10 w-full rounded-sm border bg-transparent px-3 py-2 text-base shadow-none transition-[color,box-shadow] outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="222921" className="flex flex-col items-center justify-center py-10 text-center animate-in fade-in zoom-in duration-500">
                <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Send className="size-6" />
                </div>
                <h3 className="mb-2 font-default text-xl font-bold text-foreground">Contribution Received</h3>
                <p className="mb-6 text-muted-foreground">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="rounded-sm border-primary text-primary hover:bg-primary/5">
                    Make Another Donation
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <FormField control={control} name="name" rules={{
        required: "Full name is required"
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default text-sm font-semibold">Full Name <span className="text-destructive">*</span></FormLabel>
                            <FormControl>
                                <input type="text" className={inputStyles} placeholder="Jane Doe" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default text-sm font-semibold">Email Address <span className="text-destructive">*</span></FormLabel>
                            <FormControl>
                                <input type="email" className={inputStyles} placeholder="jane@advocates.org" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default text-sm font-semibold">Phone Number</FormLabel>
                            <FormControl>
                                <input type="tel" className={inputStyles} placeholder="+1 (555) 000-0000" {...field} />
                            </FormControl>
                            <FormDescription className="text-xs">Optional: For donation verification</FormDescription>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="subject" render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-default text-sm font-semibold">Donation Purpose</FormLabel>
                            <FormControl>
                                <input type="text" className={inputStyles} placeholder="e.g. Research Fund" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            <FormField control={control} name="message" rules={{
      required: "Please include a note with your support"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-default text-sm font-semibold">Support Message <span className="text-destructive">*</span></FormLabel>
                        <FormControl>
                            <Textarea placeholder="Tell us why you're supporting responsive governance..." className="min-h-[120px] resize-y rounded-sm border-border focus-visible:ring-primary/20" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>} />

            {submitError && <div className="rounded-sm bg-destructive/10 p-3 text-sm text-destructive">
                    {submitError}
                </div>}

            <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-default font-bold">
                {isSubmitting ? <>
                        <Loader className="mr-2 size-4 animate-spin" />
                        Processing...
                    </> : <>
                        <Send className="mr-2 size-4" />
                        Complete Donation
                    </>}
            </Button>
        </Form>;
}
export default function ContactMessageSection() {
  return;
}